export default "__VITE_ASSET__f8m6xmjJ__"